import common from './common';
import errors from './errors';
import nav from './nav';
import ws from './ws';
import auth from './auth';
import dashboard from './dashboard';
import library from './library';
import practice from './practice';
import review from './review';
import history from './history';
import progress from './progress';
import exam from './exam';
import teacher from './teacher';
import settings from './settings';
import admin from './admin';

const all = [common, errors, nav, ws, auth, dashboard, library, practice, review, history, progress, exam, teacher, settings, admin];

export const messages = {
  ru: Object.assign({}, ...all.map((m) => m.ru)) as Record<string, string>,
  en: Object.assign({}, ...all.map((m) => m.en)) as Record<string, string>,
};
